import { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchCustomerById } from '../../api/customer';

const CustomerMeterDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadInspection = async () => {
            try {
                const res = await fetchCustomerById(id);
                setCustomer(res.data.data);
            } catch (err) {
                console.error('Error fetching inspection:', err);
            } finally {
                setLoading(false);
            }
        };
        loadInspection();
    }, [id]);

    const handleVerify = () => {
        navigate(`/crm/meter-form/${id}`);
    };

    if (loading) return <p>Loading...</p>;
    if (!customer) return <p>Inspection or customer not found.</p>;

    const renderDetail = (label, value) => (
        <p><strong>{label}:</strong> {value || '-'}</p>
    );

    return (
        <div className="container">
            <h3 className="mb-4">Meter Details</h3>

            <Card className="mb-4">
                <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
                    <strong>Customer Info</strong>
                    <Button size="sm" variant="success" onClick={handleVerify}>
                        ✅ Verify
                    </Button>
                </Card.Header>
                <Card.Body>
                    {renderDetail("Name", `${customer.firstName} ${customer.lastName}`)}
                    {renderDetail("Address", customer.address)}
                    {renderDetail("Contact", customer.mobile1 || customer.mobile2)}
                </Card.Body>
            </Card>

            <Tabs defaultActiveKey="meterAddress" className="mb-4">
                <Tab eventKey="meterAddress" title="Meter Address">
                    <Card className="p-3">
                        <Row>
                            <Col md={4}>{renderDetail("Latitude", customer.latitude)}</Col>
                            <Col md={4}>{renderDetail("Longitude", customer.longitude)}</Col>
                            <Col md={4}>{renderDetail("Near Meter Number", customer.nearMeterNumber)}</Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}>{renderDetail("Pole No.", customer.poleNo)}</Col>
                            <Col md={4}>{renderDetail("Route Code", customer.routeCode)}</Col>
                            <Col md={4}>{renderDetail("Sequence", customer.sequence)}</Col>
                        </Row>
                    </Card>
                </Tab>

                <Tab eventKey="serviceDetails" title="Meter Service Details">
                    <Card className="p-3">
                        <Row>
                            <Col md={4}>{renderDetail("Bill Deposit", customer.billDeposit)}</Col>
                            <Col md={4}>{renderDetail("Feeder Number", customer.feederNumber)}</Col>
                            <Col md={4}>{renderDetail("Meter Class", customer.meterClass)}</Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}>{renderDetail("Total Cost of Materials", customer.totalCostMaterials)}</Col>
                            <Col md={4}>{renderDetail("Type of Meter", customer.typeOfMeter)}</Col>
                            <Col md={4}>{renderDetail("Connected Load", customer.connectedLoad)}</Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}>{renderDetail("Total Cost of Labor and Equipment", customer.totalCostLaborEquip)}</Col>
                            <Col md={4}>{renderDetail("Size of Conductor", customer.conductorSize)}</Col>
                            <Col md={4}>{renderDetail("Size of Transformer", customer.transformerSize)}</Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}>{renderDetail("Others", customer.others)}</Col>
                            <Col md={4}>{renderDetail("Protection", customer.protection)}</Col>
                            <Col md={4}>{renderDetail("Transformer Number", customer.transformerNumber)}</Col>
                        </Row>
                    </Card>
                </Tab>

                <Tab eventKey="attachments" title="Attachments">
                    <Card className="p-3 mb-4">
                        {renderDetail("Verification Status", customer.verificationStatus)}
                        <p className="text-muted">Uploaded files and other media are not shown here.</p>

                    </Card>
                </Tab>
            </Tabs>
        </div>
    );
};

export default CustomerMeterDetail;
